import { deserialize } from 'cerialize'
import { RegionsModel, CityModel } from 'Pages/referenceBooks'

export class MerchantBranchModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public address: string
	@deserialize public city: CityModel
	@deserialize public region: RegionsModel
	@deserialize public is_deleted: boolean
}
